import { TabsContainer } from '@components/Tabs/styles'
import { Box, Tabs } from '@mui/material'
import {
	type ChangeEvent,
	type Dispatch,
	type SetStateAction,
	useCallback,
} from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router'
import { useNavigate } from 'react-router-dom'

import { Tab } from './styles'

interface Props {
	children?: React.ReactElement
	purchasedProductsCount?: number
	setPurchasedProductsSearch: Dispatch<SetStateAction<string>>
	setReceivedRequestsSearchParams: Dispatch<SetStateAction<string>>
	purchasedProductsSearch?: string
	receivedProductRequestsCount?: number
	receivedProductRequestsSearch?: string
	pactRequestsCount?: number
	catenaRequestsCount?: number
}

const tabPath = [
	'/products/purchased',
	'/products/received-requests',
	'/products/pact-requests',
	'/products/catena-requests',
] as const

const TabHeader: React.FC<Props> = ({
	children,
	purchasedProductsCount,
	setPurchasedProductsSearch,
	setReceivedRequestsSearchParams,
	purchasedProductsSearch,
	receivedProductRequestsCount,
	receivedProductRequestsSearch,
	pactRequestsCount,
	catenaRequestsCount,
}) => {
	const { t } = useTranslation()
	const navigate = useNavigate()
	const { pathname, search } = useLocation()
	const value = tabPath.findIndex(path => pathname.startsWith(path))

	const changeTab = useCallback(
		(_: ChangeEvent<unknown>, newValue: number) => {
			if (value === 0) {
				setPurchasedProductsSearch(search)
			} else if (value === 1) {
				setReceivedRequestsSearchParams(search)
			}

			if (newValue !== value) {
				if (newValue === 0) {
					navigate(`${tabPath[newValue]}${purchasedProductsSearch || ''}`)
				} else if (newValue === 1) {
					navigate(`${tabPath[newValue]}${receivedProductRequestsSearch || ''}`)
				} else if (newValue === 2) {
					navigate(tabPath[newValue])
				} else if (newValue === 3) {
					navigate(tabPath[newValue - 1]) // TODO(jonB): Remove the "-1" when view is fully implemented.
				}
			}
		},
		[
			navigate,
			purchasedProductsSearch,
			receivedProductRequestsSearch,
			setPurchasedProductsSearch,
			search,
			value,
			setReceivedRequestsSearchParams,
		]
	)

	if (value < 0) {
		return null
	}

	return (
		<Box py={2}>
			{/* TODO(Jonathan): Replace with @components/Tabs */}
			<TabsContainer>
				<Tabs
					value={value}
					onChange={changeTab}
					indicatorColor="primary"
					variant="fullWidth"
				>
					<Tab
						label={`${t('purchasedProducts')} ${
							purchasedProductsCount === undefined
								? ''
								: `(${purchasedProductsCount})`
						}`}
					/>
					<Tab
						label={`${t('receivedProductRequests')} ${
							receivedProductRequestsCount === undefined
								? ''
								: `(${receivedProductRequestsCount})`
						}`}
					/>
					<Tab
						label={`${t('tabs.pactRequests')} ${
							pactRequestsCount === undefined ? '' : `(${pactRequestsCount})`
						}`}
					/>
					<Tab
						label={`${t('tabs.catenaRequests')} ${
							catenaRequestsCount === undefined
								? ''
								: `(${catenaRequestsCount})`
						}`}
						disabled
					/>
				</Tabs>
			</TabsContainer>
			{children}
		</Box>
	)
}

export { TabHeader }
